
if (typeof window !== 'undefined') {
	module.exports = window; // eslint-disable-line no-undef
} else {
	const jsdomModuleName = 'jsdom'; // fool browserify
	const { JSDOM } = require(jsdomModuleName);
	const jsdom = new JSDOM();
	jsdom.window._jsdom = jsdom;
	module.exports = jsdom.window;
}
